( function ( $ ) {

  function resize ( $h2 ) {
    const $section = $h2.closest( 'section.founder-section' );
    const $span = $( 'span', $h2 );
    $section.css( '--hr-space', `${ $h2.width() - $span.width() }px` );
  }

  const founder_observer = new ResizeObserver( entries => {
    for ( let entry of entries ) {
      resize( $( entry.target ) );
    }
  });


  $( function () {
    $( 'section.founder-section h2' ).each( function () {
      founder_observer.observe( this );
    });
  });

})( jQuery );